import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import SettingsPrivacyController from './controller';

export default class SettingsPrivacyRoute extends Route {
  @service features!: FeaturesService;

  crumb() {
    return {
      name: 'Privacy & Data',
      path: this.routeName,
    };
  }

  resetController(controller: SettingsPrivacyController, isExiting: boolean) {
    if (isExiting) {
      controller.set('expandAccessControls', false);
    }
  }
}
